export const LibraryIcon = ({ size = 20 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 4.20312C0.45 4.20312 0 4.65312 0 5.20312V18.2031C0 19.3031 0.9 20.2031 2 20.2031H15C15.55 20.2031 16 19.7531 16 19.2031C16 18.6531 15.55 18.2031 15 18.2031H3C2.45 18.2031 2 17.7531 2 17.2031V5.20312C2 4.65312 1.55 4.20312 1 4.20312ZM18 0.203125H6C4.9 0.203125 4 1.10312 4 2.20312V14.2031C4 15.3031 4.9 16.2031 6 16.2031H18C19.1 16.2031 20 15.3031 20 14.2031V2.20312C20 1.10312 19.1 0.203125 18 0.203125ZM10 12.7031V3.70312L15.47 7.80313C15.74 8.00313 15.74 8.40312 15.47 8.60312L10 12.7031Z"
        fill="currentColor"
      />
    </svg>
  );
};
